<script>
import { required } from "vuelidate/lib/validators";
import validationMessages from '@/components/validations'
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Games from "@/services/Games";
import Swal from "sweetalert2";

export default {
  components:{
    validationMessages , vueDropzone: vue2Dropzone
  },
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      question: { en: '' }, // Now an object for multiple languages
      difficulty: 'medium', // Added difficulty field
      answers: [
        { answer: { en: "" }, is_correct: false },
        { answer: { en: "" }, is_correct: false },
        { answer: { en: "" }, is_correct: false },
        { answer: { en: "" }, is_correct: false }
      ],
      min_answers: 0,
      image_url: null,
      photoDeletedCompanyImage : false ,
      photoDeletedLogoUrl : false ,
      submitted: false,
      showModal: false,
      tryingToEdit: false,
      verified_checked: true,
      correctAnswer: null,
      successMessage: '',
      dropzoneOptions_primary: {
        url: '/',
        autoProcessQueue: false,
        addRemoveLinks: true,
        thumbnailWidth: 200,
        thumbnailMethod: 'contain',
        maxFilesize: 4,
        acceptedFiles: 'image/jpeg,image/png,image/gif,image/bmp,image/webp',
        maxFiles: 3,
      },
    };
  },
  validations: {
    question: {
      en: { required } // Validate English question
    },
    difficulty: {
      required
    },
    answers: {
      $each: {
        answer: {
          en: { required },
        },
      },
    },
    correctAnswer: {
      required(value) {
        return value !== null && value !== undefined;
      },
    },
  },

  methods: {
    async addQuizQuestion(){
      this.tryingToEdit = true;
      this.submitted = true;
      this.$v.$touch()

      if (this.$v.$invalid || this.correctAnswer === null) {
        if (this.correctAnswer === null) {
          this.failedmsg("Please select one correct answer");
        }
        this.tryingToEdit = false;
      } else {
        try {

          this.answers.forEach((answer, index) => {
            answer.is_correct = index === this.correctAnswer;
          });
          // Prepare data according to API requirements
          const formData = new FormData();

          // Add required fields for API
          formData.append('difficulty', this.difficulty);
          formData.append('question[en]', this.question.en);
          formData.append('is_approved', '');
          formData.append('csrf_token', this.csrf_token);

          // Add options (answers) - API expects exactly 4
          this.answers.forEach((answer, index) => {
            if (answer.answer.en && answer.answer.en.trim() !== '') {
              formData.append(`options[${index}][answer][en]`, answer.answer.en);
              formData.append(`options[${index}][is_correct]`, answer.is_correct ? 1 : 0);
            }
          });

          // Add image if exists
          if (this.image_url) {
            formData.append('image', this.image_url);
          }

          await Games.addQuizQuestion(formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((response) => {
            Swal.fire(
              "Quiz Question",
              "Quiz question has been saved successfully",
              "success"
            );
            this.closeModal();
          }).catch(error => {
            let errorMessage = "An unexpected error occurred";

            if (error.response && error.response.data && error.response.data.error) {
              // Handle array of errors from API
              if (Array.isArray(error.response.data.error)) {
                errorMessage = error.response.data.error.join(', ');
              } else {
                errorMessage = error.response.data.error;
              }
            } else if (error.message) {
              errorMessage = error.message;
            } else if (error.request) {
              errorMessage = "No response received from server";
            }

            this.failedmsg(errorMessage);
            console.error("Quiz question error:", error);
          }).finally(() => {
            this.refreshData();
            this.tryingToEdit = false;
          });
        } catch (error) {
          let errorMessage = "An unexpected error occurred";

          if (error.response && error.response.data && error.response.data.error) {
            if (Array.isArray(error.response.data.error)) {
              errorMessage = error.response.data.error.join(', ');
            } else {
              errorMessage = error.response.data.error;
            }
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.failedmsg(errorMessage);
          console.error("Quiz question error:", error);
          this.tryingToEdit = false;
        }
      }
    },

    selectFileImageUrl(files) {
      setTimeout(() => {
        let queuedFiles = this.$refs.myVueDropzone_image_url.getQueuedFiles();
        if (queuedFiles.length > 1) {
          this.failedmsg('You can only have one image');

          files.forEach((value) => {
            this.$refs.myVueDropzone_image_url.removeFile(value);
          });
        }
        this.image_url = queuedFiles[0] || null;
        this.photoDeletedLogoUrl = false;
      }, 250);
    },

    refreshData() {
      this.$emit('onRefresh');
    },

    closeModal() {
      this.showModal = false;
      this.resetProps();
    },

    resetProps(){
      this.question = { en: '' };
      this.difficulty = 'medium';
      this.answers = [
        { answer: { en: "" }, is_correct: false },
        { answer: { en: "" }, is_correct: false },
        { answer: { en: "" }, is_correct: false },
        { answer: { en: "" }, is_correct: false }
      ];
      this.min_answers = 0;
      this.image_url = null;
      this.submitted = false;
    },

    successmsg(message) {
      this.$bvToast.toast(message, {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },

    failedmsg(message) {
      this.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
    }
  },
};
</script>

<template>
  <b-modal v-model="showModal" @hidden="resetProps"  id="add_new_quiz_question" title=" Add new Quiz Question" title-class="font-18" size="lg" centered>
    <form @submit.prevent="addQuizQuestion">
      <div class="row">
        <div class="col-12 col-lg-12">
          <b-form-group label-for="formrow-difficulty-input" class="mb-3">
            <label for="difficulty">Difficulty</label>
            <b-form-select
                v-model="difficulty"
                :options="[
                  { value: 'easy', text: 'Easy' },
                  { value: 'medium', text: 'Medium' },
                  { value: 'hard', text: 'Hard' }
                ]"
                id="difficulty"
                :class="{
                  'is-invalid': submitted && $v.difficulty.$error,
                }"
            >
            </b-form-select>
            <validationMessages v-if="submitted" :fieldName="'Difficulty'" :validationName="$v.difficulty"></validationMessages>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label-for="formrow-external-input" class="mb-3">
            <label for="name">Quiz Question (English)</label>
            <b-form-input
                v-model.trim="question.en"
                type="text"
                id="question"
                aria-describedby="question-feedback"
                :class="{
                  'is-invalid': submitted && $v.question.en.$error,
                }"
            >
            </b-form-input>
            <validationMessages v-if="submitted" :fieldName="'Quiz Question'" :validationName="$v.question.en"></validationMessages>
          </b-form-group>
        </div>
        <!-- Answers Section with Improved Layout -->
        <div class="col-12">
          <div class="answers-section">
            <label class="form-label mb-3">
              <span>Answers (English)</span>
              <small class="text-muted d-block mt-1">Select one correct answer</small>
            </label>
            <validationMessages
                v-if="submitted && $v.correctAnswer.$error"
                :fieldName="'Correct answer'"
                :validationName="$v.correctAnswer"
                class="mb-2 text-danger"
            />
            <div v-for="(answer, index) in answers" :key="index" class="answer-item p-1">
              <div class="row align-items-center">
                <div class="col-md-9">
                  <b-form-input
                      v-model.trim="answer.answer.en"
                      type="text"
                      :id="'answer-' + index"
                      :placeholder="'Answer ' + (index + 1)"
                      class="answer-input"
                      :class="{ 'is-invalid': submitted && $v.answers.$each[index].answer.en.$error }"
                  >
                  </b-form-input>
                  <validationMessages
                      v-if="submitted && $v.answers.$each[index].answer.en.$error"
                      :fieldName="`Answer ${index + 1}`"
                      :validationName="$v.answers.$each[index].answer.en"
                  />
                </div>
                <div class="col-md-3">
                  <div class="correct-option d-flex align-items-center justify-content-center">
                    <b-form-radio
                        v-model="correctAnswer"
                        :name="'correct-answer'"
                        :value="index"
                        :id="'correct-' + index"
                        class="me-3"
                    >
                      Correct
                    </b-form-radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr>
        <div class="form-group" >
          <label for="image_url">Image: (Max size:4 MB)</label>
          <template>
            <vue-dropzone
                id="image_url"
                ref="myVueDropzone_image_url"
                :use-custom-slot="true"
                :options="dropzoneOptions_primary"
                @vdropzone-files-added="selectFileImageUrl"
                no-progress-bar
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>Drop file here or click to upload.</h4>
              </div>
            </vue-dropzone>
          </template>
        </div>
      </div>
      <input type="hidden" name="csrf_token" v-model="csrf_token">
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="addQuizQuestion" :disabled="tryingToEdit">
        <b-spinner v-show="tryingToEdit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
<style>
.custom-control-input
{
  margin-right: 10px;
}
</style>
